import { render, staticRenderFns } from "./ProfileAvatar.vue?vue&type=template&id=41a741c0"
import script from "./ProfileAvatar.vue?vue&type=script&lang=ts"
export * from "./ProfileAvatar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports